import * as Yup from "yup";

export const PhoneCheckerSchema = () =>
  Yup.object({
    phone: Yup.string()
      .required("Phone is required")
      .matches(/^(^\+251|^251|^0)?9\d{8}$/, "Phone format is not valid"),
  });

export const UserSchema = () =>
  Yup.object({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Email is not valid"),
    phone: Yup.string()
      .required("Phone is required")
      .matches(/^(^\+251|^251|^0)?9\d{8}$/, "Phone format is not valid"),
    gender: Yup.string().required("Gender is required"),
    role: Yup.string().required("Role is required"),
  });

export const CompanySchema1 = () =>
  Yup.object({
    name: Yup.string().required("Name is required"),
    ADMLimit: Yup.number().required("ADM Limit is required"),
    address: Yup.string().required("Address is required"),
    officeNumber: Yup.string().required("Office Number is required"),
    // .matches(/^(^\+251|^251|^0)?9\d{8}$/, "Phone format is not valid"),
  });

export const CompanySchema2 = () =>
  Yup.object({
    bank: Yup.string().required("Bank is required"),
    deposit: Yup.number().required("Deposit is required"),
    // .min(1000, "Deposit can't be below 0")
    serviceChargeLocal: Yup.number().required(
      "Local Service Charge is required"
    ),
    // serviceChargeInternational: Yup.number().required(
    //   "International Service Charge is required"
    // ),
    // serviceChargeInternationalBusiness: Yup.number().required(
    //   "International Business Service Charge is required"
    // ),
    transactionId: Yup.string()
      // .length(3, "Transaction ID is not valid")
      // .min(10, "Transaction ID is not valid")
      .required("Transaction ID is required"),
    // amount: Yup.number().required("Amount is required"),
    // creditLimit: Yup.number().required("Credit Limit is required"),
  });

export const EnterpriseSchema = () =>
  Yup.object({
    bank: Yup.string().when("method", {
      is: (val) => val === "prePaid",
      then: Yup.string().required("Bank is required"),
      otherwise: Yup.string(),
    }),
    deposit: Yup.number().when("method", {
      is: (val) => val === "prePaid",
      then: Yup.number().required("Deposit is required"),
      otherwise: Yup.number(),
    }),
    method: Yup.string().required("Method is required"),
    serviceChargeLocal: Yup.number().required(
      "Local Service Charge is required"
    ),
    serviceChargeInternational: Yup.number().required(
      "International Service Charge is required"
    ),
    // serviceChargeInternationalBusiness: Yup.number().required(
    //   "International Business Service Charge is required"
    // ),
    transactionId: Yup.string().when("method", {
      is: (val) => val === "prePaid",
      then: Yup.string().required("Transaction ID is required"),
      otherwise: Yup.string(),
    }),
  });

export const BillingSchema = () =>
  Yup.object({
    bank: Yup.string().required("Bank is required"),
    deposit: Yup.number()
      .min(1, "Deposit can't be below 1")
      .required("Deposit is required"),
    // transaction: Yup.string()
    //   .min(3, "Transaction ID is not valid")
    //   .required("Transaction ID is required"),
    transaction: Yup.string().when("bank", {
      is: (val) => val !== "short-term-credit",
      then: Yup.string().required("Transaction is required"),
      otherwise: Yup.string(),
    }),
  });

export const ManualBillingSchema = () =>
  Yup.object({
    // transactionId: Yup.string().required("Transaction ID is required"),
    baseFare: Yup.number().required("Base Fare is required"),
    serviceCharge: Yup.number().required("Service Charge is required"),
    totalAmount: Yup.number().required("Total Amount is required"),
    paymentMethod: Yup.string().required("Payment Method is required"),
    // typeOfBilling: Yup.string().required("Type of Billing is required"),
    typeOfChannel: Yup.string().required("Type is required"),
    flight: Yup.object({
      origin: Yup.string().required("Origin is required"),
      destination: Yup.string()
        .required("Destination is required")
        .test(
          "different-from-origin",
          "Destination should be different from origin",
          function (value) {
            return value !== this.parent.origin;
          }
        ),
      PNR: Yup.string().required("PNR is required"),
      carrier: Yup.string().required("Carrier is required"),
      departureDate: Yup.string().required("Departure Date is required"),
    }),
    // toBeRefunded: Yup.number().when("typeOfBooking", {
    //   is: (val) => val === "halfRefund",
    //   then: Yup.number().required("To Be Refunded Amount is required"),
    //   otherwise: Yup.number(),
    // }),
    halfRefund: Yup.object().when("typeOfBooking", {
      is: (val) => val === "halfRefund",
      then: Yup.object({
        toBeRefunded: Yup.number()
          .min(0.01, "To be refunded must be greater than 0")
          .required("To be refunded is required"),
        totalPaidAmount: Yup.number()
          .min(0.01, "Total Paid Amount must be greater than 0")
          .required("Total Paid Amount is required"),
      }),
      otherwise: Yup.object(),
    }),
    passengers: Yup.array().of(
      Yup.object({
        // firstName: Yup.string().required("First Name is required"),
        // lastName: Yup.string().required("Last Name is required"),
        ticketNumber: Yup.string().required("Ticket Number is required"),
        passengerSC: Yup.string().required("Passenger SC is required"),
      })
    ),
  });

export const ManualEMDSchema = () =>
  Yup.object({
    paymentMethod: Yup.string().required("Payment Method is required"),
    typeOfChannel: Yup.string().required("Type is required"),
    passengers: Yup.array().of(
      Yup.object({
        ticketNumber: Yup.string().required("Ticket Number is required"),
        price: Yup.number().required("EMD Amount is required"),
        passengerSC: Yup.number().required("Service Charge is required"),
      })
    ),
    baseFare: Yup.number().required("Base Fare is required"),
    serviceCharge: Yup.number().required("Service Charge is required"),
    totalAmount: Yup.number().required("Total Amount is required"),
  });

export const ShortTermCreditSettlementSchema = () =>
  Yup.object({
    amount: Yup.number().required("Amount is required"),
    bank: Yup.string().required("Bank is required"),
    transaction: Yup.string().when("bank", {
      is: (val) => val !== "wallet",
      then: Yup.string().required("Transaction is required"),
      otherwise: Yup.string(),
    }),
    reason: Yup.string().required("Reason is required"),
  });

export const formatPhone = (phone) => {
  if (phone.startsWith("0")) {
    return phone;
  } else {
    return `0${phone}`;
  }
};
